import React from "react";
import {PageHeader} from "antd";

import NotificationCampaings from "../settings/components/photocontrol/NotificationCampaings";

export default function NotificationCampaignsPage() {
  return (
    <>
      <PageHeader
        className="site-page-header"
        title="Рассылка уведомлений"
      />
      <NotificationCampaings active={true}/>
    </>
  )
}
